const getQueryVariables = (ids = []) => {
    let variables = {
        req: {
            ids,
            imageParams: {
                limit: 1,
                sources: [
                    'EDAM_OBM',
                    'EDAM_Digital',
                    'EDAM',
                    'Wikimedia',
                    'Trover',
                ],
            },
        },
    };
    return variables;
};

const getPopularDestinationsData = (data) => {
    try {
        const imageData = data.destinationImage;
        if (imageData.length > 0) {
            return imageData;
        }
        return false;
    } catch (err) {
        return false;
    }
};

export {getQueryVariables, getPopularDestinationsData};
